import React from 'react';
import Seo from '../components/shared/Seo';
import AnimatedSection from '../components/ui/AnimatedSection';
import { useTranslation } from 'react-i18next';

const TermsAndConditionsPage: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <>
      <Seo
        title="Terms and Conditions | The Action Firm"
        description="Terms and conditions for using The Action Firm website."
        alternateLangs={['en']}
      />
      <div className="pt-32 pb-24">
        <AnimatedSection className="mx-auto max-w-4xl px-6">
          <h1 className="text-4xl md:text-5xl font-serif font-bold mb-8">Terms and Conditions</h1>
          <div className="prose prose-invert max-w-none prose-lg">
            <p>Last Updated: {new Date().toLocaleDateString()}</p>
            
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.</p>
            
            <h2>2. No Legal Advice</h2>
            <p>The information provided on this website does not, and is not intended to, constitute legal advice; instead, all information, content, and materials available on this site are for general informational purposes only.</p>
            
            <h2>3. No Attorney-Client Relationship</h2>
            <p>Use of, and access to, this website or any of the links or resources contained within the site do not create an attorney-client relationship between the reader, user, or browser and website authors, contributors, contributing law firms, or committee members and their respective employers.</p>
            
            <h2>4. Disclaimer of Warranties</h2>
            <p>This website is provided "as is" without any representations or warranties, express or implied.</p>
            
            <h2>5. Limitation of Liability</h2>
            <p>The Action Firm will not be liable to you in relation to the contents of, or use of, or otherwise in connection with, this website.</p>
          </div>
        </AnimatedSection>
      </div>
    </>
  );
};

export default TermsAndConditionsPage;
